import React from "react";
import "./FilterComponents.scss"
import CustomCheckbox from "../../../components/CustomCheckbox/CustomCheckbox";
const CheckBoxContainer = ({ item }) => {
    return (
        <div className="CheckBoxContainer">
            <CustomCheckbox label={item.Label} />
            <div className="count-container">({item.count})</div>
        </div>
    )
}
export default CheckBoxContainer